// components/herosection.js
import React from 'react';
import backdrop from "../assets/images/backdrop.png";

function GymHerosection({ pageData }) {
    return (
        <div>
            {pageData?.herosections?.map((section, index) => (
                section?.isactive ? (
                    <div
                        key={section.id || index}
                        className='herocard_1 position-relative mb-3'
                        style={{
                            backgroundColor: section.backgroundcolor,
                        }}
                    >
                        <div className='container'>
                            <div className='row align-items-center' style={{
                                flexDirection: section.contentposition === 'left' ? 'row' : 'row-reverse'
                            }}>
                                <div className='col-sm-12 col-md-6'>
                                    <div className='herosection-left' style={{ flex: 1, padding: '1rem' }}>
                                        <div
                                            className="ps-0"
                                            dangerouslySetInnerHTML={{ __html: section.subtitle || "--" }}
                                        />
                                        <div
                                            className="ps-0"
                                            dangerouslySetInnerHTML={{ __html: section.title || "--" }}
                                        />
                                        <hr className='mt-0 mb-3 w-25 underline-color'></hr>
                                        <div
                                            className="ps-0"
                                            dangerouslySetInnerHTML={{ __html: section.description || "--" }}
                                        />
                                        {section?.button?.enabled && (
                                            <a
                                                className="btn"
                                                style={{
                                                    color: section.button.color,
                                                    backgroundColor: section.button.bgcolor,
                                                    borderColor: `2px solid ${section.button.bordercolor}`,
                                                    borderRadius: section.button.borderradius || '4px',
                                                    padding: section.button.size === 'sm' ? '0.25rem 0.5rem' :
                                                        section.button.size === 'lg' ? '0.5rem 1rem' : '0.375rem 0.75rem',
                                                    fontSize: section.button.size === 'sm' ? '0.875rem' :
                                                        section.button.size === 'lg' ? '1.25rem' : '1rem',
                                                }}
                                                href={section.button.url}
                                            >
                                                {section.button.text}
                                            </a>
                                        )}
                                    </div>
                                </div>
                                <div className='col-sm-12 col-md-6'>
                                    <div className='herosection-right'
                                        style={{ flex: 1, padding: '1rem' }}>
                                        {section.heroimage && (
                                            <img src={section.heroimage} alt="" className="img-fluid" />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {index % 2 == 0 ? <div className='backdrop elemt1'>
                            <img src={backdrop} alt="" />
                        </div> : <div className='backdrop elemt2'>
                            <img src={backdrop} alt="" />
                        </div>}

                    </div>
                ) : null
            ))}
        </div>
    );
}

export default GymHerosection;